import * as ls from './loginSession';
import _ from 'lodash';
import Cookies from "universal-cookie";
import { getAcApiUrl } from './helper';
import { getAccessHeader } from '../utils/loginSession';
import { toastMsg } from "../components/toastMessage/toastMessage";
import jwt from "jsonwebtoken";
const axios = require("axios");
const cookie = new Cookies();

axios.defaults.timeout = 60000;
/* 请求拦截器 */
axios.interceptors.request.use(
    (config) => {
        // getSwitchStatusState()
        const accessToken = cookie.get("accessToken");
        if (accessToken) {
            if (sessionStorage.getItem('updateTokenTime')) {
                const currentDateTime = new Date().getTime()//当前时间
                const expDateTime = sessionStorage.getItem('updateTokenTime'); //Token 過期時間
                if (Number(currentDateTime) >= Number(expDateTime)) {
                    refreshAccessToken()
                    sessionStorage.removeItem('updateTokenTime')
                }
            } else {
                const currentDateTime = new Date().getTime()//当前时间
                const expDateTime = jwt?.decode(accessToken)?.exp * 1000; //Token 過期時間
                const endDateTime = (jwt?.decode(accessToken)?.exp * 1000) - (60000 * 3); //設定過期更新Token時間 (Token 過期時間 - 3分鐘)
                if (currentDateTime >= endDateTime && expDateTime > currentDateTime) {
                    refreshAccessToken()
                } else if (expDateTime < currentDateTime) {
                    logoutSession()
                }
            }
        }
        return config;
    },
    (error) => {
        return error;
    }
);
/* 响应拦截器 */
axios.interceptors.response.use(
    (response) => {
        // 业务级错误处理
        // const { code } = response?.data;
        // if (code && code !== "0") {
        // }
        return response
    },
    (error) => {
        // 网络级错误处理
        if (error.response) {
            const { status, data } = error.response;
            if (status == 401) {
                logoutSession();
                toastMsg("頁面已過期。請重新登錄");
                setTimeout(() => {
                    redirectToLogin("a");
                }, 300);
                throw new axios.Cancel();
            }
            //服务不可用
            if (status == 503) {
                /**
                 * 当 User 在 CS 中配置开启网站维护状态时，访问BFF中的接口时将返回 状态码 503 
                */
                if (typeof window !== undefined) {
                    location.reload()
                }
            }
        }
        if (error && error.message && error.message.includes('timeout')) {   // 判断请求异常信息中是否含有超时timeout字符串
            console.log('请求超时')
        }
        return error

    }
);
export default axios;

const getSwitchStatusState = _.debounce(function () {
    const apiUrl = getAcApiUrl();
    axios({
        headers: getAccessHeader(),
        method: 'post',
        url: `${apiUrl}/anon/getMaintenanceStatus`,
        data: {},
    }).then((res) => {
        const axiosData = res?.data;
        if (typeof window !== undefined) {
            const maintenanceStatus = localStorage.getItem('maintenanceStatus')
            if (maintenanceStatus !== null && maintenanceStatus !== 'null' && JSON.stringify(maintenanceStatus) !== "{}") {
                let json = JSON.parse(maintenanceStatus);
                if (json.enabled !== res.enabled) {
                    localStorage.setItem('maintenanceStatus', JSON.stringify(axiosData))
                }
            } else {
                localStorage.setItem('maintenanceStatus', JSON.stringify(axiosData))
            }
        }
    })
}, 10000)

const refreshAccessToken = _.debounce(function (e) {
    if (typeof window !== 'undefined') {
        const loginSDK = window?.lcSDK;
        loginSDK?.util?.refreshAccessToken(res => {
            if (!res.success) {
                if (
                    protectedList.length > 0 &&
                    protectedList.some(route => window.location.pathname.match(route))
                ) {
                    if (localStorage.getItem('debug')) {
                        alert('sdk.refreshAccessToken: ' + JSON.stringify(res));
                        alert(res?.message);
                    }
                }
                try {
                    axios.post(getAcApiUrl() + '/anon/eventLog', {
                        type: 'error',
                        message: `Refresh token - SDK.RefreshTokenError ${JSON.stringify(res)}`,
                    });
                } catch (e) {
                }
                window.refreshTokenFlag = false;
                toLogout('r');
            }
            closeSDKLoadingIco();
        });
    }
}, 5000)

//登出
const logoutSession = async router => {
    if (typeof window !== 'undefined') {
        const cookies = new Cookies();
        if (window.lcSDK) {
            const loginSDK = window.lcSDK;
            loginSDK.util.removeTokens();
        }
        cookies.set('ada', '', ls.cookieOption(-1));
        cookies.set('vAda', '', ls.cookieOption(-1));
        cookies.set('role', 'Guest', ls.cookieOption(365));
        cookies.set('accessToken', '', ls.cookieOption(-1));
        cookies.set('refreshToken', '', ls.cookieOption(-1));
        cookies.set('tokenExpires', '', ls.cookieOption(-1));
        cookies.set('user', '', ls.cookieOption(-1));
        cookies.set('loginType', '', ls.cookieOption(-1));
        cookies.set('loginMemberType', '', ls.cookieOption(-1));


        localStorage.removeItem('lastPageAction');
        localStorage.removeItem('==ZXhwaXJlVGltZQ==');
        localStorage.removeItem('menuList');
        localStorage.removeItem('nav');
        localStorage.removeItem('navFooter');
        localStorage.removeItem('sopDetail');
        localStorage.removeItem('onbehalf');
        localStorage.removeItem('corpFlag');
        localStorage.removeItem('sharebarTNC');
        localStorage.removeItem('sharebarTNCAgreed');
        localStorage.removeItem('switchRecipient_regPurchasers');
        localStorage.removeItem('switch_address');
        localStorage.removeItem('chatbot');
        localStorage.removeItem('sopModify')
        localStorage.removeItem('depreciated');
        localStorage.removeItem('USER_ALL_PROMOTIONS_LIST')
        if (router) {
            router.push('/login');
        }
    } else {
        console.log('Logout session valid on browser session only');
    }
};
const closeSDKLoadingIco = () => {
    if (typeof window !== 'undefined') {
        try {
            if (document.querySelector('#loadingToast')) document.querySelector('#loadingToast').remove();
        } catch (e) {
            console.log('nothing');
        }
    }
};
const toLogout = (reason = '') => {
    let forceRedirect = false;
    let path = window.location.pathname;
    if (window.refreshTokenProtectedList.length > 0) {
        forceRedirect = window.refreshTokenProtectedList.some(route => path.match(route));
    } else {
        if (window.location.pathname !== '/login') forceRedirect = true;
    }
    logoutSession();
    if (forceRedirect) {
        window.location.href =
            '/login?exp=' +
            reason +
            '&h=' +
            btoa(window.location.pathname + (window.location.search || ''));
    }
};
export const redirectToLogin = (redirectCode = "") => {
    if (typeof window === "undefined") return;
    window.location.href = "/login?exp=a" + redirectCode + "&h=" + btoa(window.location.pathname);
};